export async function collectPages<T>(load: (page: number) => Promise<{ results: T[]; count: number }>): Promise<T[]> {
  const results: T[] = [];
  for (let page = 1; ; page++) {
    const batch = await load(page);
    results.push(...batch.results);
    if (results.length >= batch.count || batch.results.length === 0) return results;
  }
}
